import { useCallback } from 'react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryState } from '@cvt/hooks/useQueryState';
import { UserContext } from '@modules/Users/contexts';
import { AuthContext } from '../contexts';

export const useHandleAuthRedirect = () => {
  const [redirectTo, setRedirectTo] = useQueryState('redirect');
  const { user: me } = React.useContext(UserContext);
  const { isUserVerified } = React.useContext(AuthContext);

  const navigate = useNavigate();

  const handleRedirect = useCallback(() => {
    if (redirectTo && isUserVerified && me?.onboarded) {
      navigate(redirectTo);
      setRedirectTo(undefined, true);
      return true;
    }
    return false;
  }, [redirectTo, isUserVerified, me, navigate, setRedirectTo]);

  return handleRedirect;
};
